<div
	class="obg-m-deposit-limit-calculator-container-title"
	test-id="deposit-limit-calculator-title"
	data-test-id="deposit-limit-calculator-title"
>
	<h3 class="title-text">{{ 'deposit-limit-calculator.title' | translate }}</h3>
	<div
		class="info-icon"
		test-id="deposit-limit-calculator-info-icon"
		data-test-id="deposit-limit-calculator-info-icon"
		(click)="openInfoModal()"
	>
		<span matSuffix class="ico-information-circle"></span>
	</div>
</div>

<mat-tab-group
	animationDuration="0ms"
	[selectedIndex]="selectedTabIndex"
	[attr.mat-stretch-tabs]="stretchedTabs"
	(selectedIndexChange)="selectedTabClick($event)"
	[attr.test-id]="'deposit-limit-calculator-tab-group'"
	[attr.data-test-id]="'deposit-limit-calculator-tab-group'"
>
	<mat-tab [label]="'deposit-limit-calculator.tab.amount' | translate">
		<ng-template matTabContent>
			<obg-m-deposit-limit-calculator-result
				*ngIf="calculation else amountForm"
				(reset)="reset()"
				[calculation]="calculation"
			>
			</obg-m-deposit-limit-calculator-result>

			<ng-template #amountForm>
				<obg-m-deposit-limit-calculator-form
					[amountMaxValidator]="depositLimitAmount"
					[calculationError]="calculationError"
					[busy]="isBusy$ | async"
					[currencyCode]="currencyCode"
					[formGroup]="formGroupAmount"
					(calculate)="onCalculate($event)"
					(inputChange)="onInputChange($event)"
					test-id="deposit-limit-calculator-amount-form"
					data-test-id="deposit-limit-calculator-amount-form"
				>
				</obg-m-deposit-limit-calculator-form>
			</ng-template>
		</ng-template>
	</mat-tab>

	<mat-tab test-id="deposit-limit-calculator-tab-date" [label]="'deposit-limit-calculator.tab.date' | translate">
		<ng-template matTabContent>
			<obg-m-deposit-limit-calculator-result
				*ngIf="calculation else dateForm"
				(reset)="reset()"
				[calculation]="calculation"
			>
			</obg-m-deposit-limit-calculator-result>

			<ng-template #dateForm>
				<obg-m-deposit-limit-calculator-form
					[amountMaxValidator]="depositLimitAmount"
					[calculationError]="calculationError"
					[busy]="isBusy$ | async"
					[currencyCode]="currencyCode"
					[formGroup]="formGroupDate"
					[hoursOfTheDay]="remainingHoursSelectable"
					[startDate]="startDate"
					(calculate)="onCalculate($event)"
					(inputChange)="onInputChange($event)"
					(updateStartDate)="updateStartDate($event)"
					test-id="deposit-limit-calculator-date-form"
					data-test-id="deposit-limit-calculator-date-form"
				>
				</obg-m-deposit-limit-calculator-form>
			</ng-template>
		</ng-template>
	</mat-tab>
</mat-tab-group>
